import { useState } from "react";
import { Loader2, Mail } from "lucide-react";
import { api, errMsg } from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";

export function EmailRequiredDialog() {
  const { profiles, refresh } = useAuth();
  const main = profiles.find((p) => !p.is_child);
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  if (!main || main.email) return null;
  const save = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      await api.put(`/me/profile/${main.id}`, { email });
      await refresh();
    } catch (err) {
      setError(errMsg(err));
    } finally {
      setBusy(false);
    }
  };
  return (
    <Dialog open>
      <DialogContent
        className="max-w-sm [&>button]:hidden"
        onEscapeKeyDown={(e) => e.preventDefault()}
        onPointerDownOutside={(e) => e.preventDefault()}
        onInteractOutside={(e) => e.preventDefault()}
        data-testid="email-required-dialog"
      >
        <DialogHeader>
          <div className="mb-1 flex h-11 w-11 items-center justify-center rounded-full bg-[#E3EDD9]"><Mail className="h-5 w-5 text-[#1A3323]" /></div>
          <DialogTitle>Lengkapi email kamu</DialogTitle>
          <DialogDescription>Email sekarang wajib untuk semua climber, supaya kami bisa mengirim info penting tentang akun dan event.</DialogDescription>
        </DialogHeader>
        <form onSubmit={save} className="space-y-3">
          <Input type="email" required className="h-11" placeholder="nama@email.com" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="email-required-input" />
          {error && <p className="text-sm text-red-700" data-testid="email-required-error">{error}</p>}
          <Button type="submit" disabled={busy} className="h-12 w-full rounded-xl font-bold" data-testid="email-required-submit">
            {busy && <Loader2 className="mr-2 h-4 w-4 animate-spin" />} Simpan email
          </Button>
        </form>
      </DialogContent>
    </Dialog>
  );
}
